import React, { useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const LeaveCommentForm = ({
    comment,
    setComment,
    handleSubmitComment,
    feedbackLoading,
}) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({});

    const handlePostComment = () => {
        let newErrors = {};
        if (!name.trim()) newErrors.name = "Name is required";
        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = "Please enter a valid email";
        }
        if (!comment.trim()) {
            newErrors.comment = "Comment is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        if (handleSubmitComment) {
            handleSubmitComment({ name, email, comment });
            setName("");
            setEmail("");
            setErrors({});
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
                sx={{
                    color: "#0C141B",
                    fontFamily: "Inter",
                    fontSize: { xs: "18px", sm: "20px", md: "24px" },
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "34px",
                    marginBottom: "10px",
                }}
            >
                Leave a Comment
            </Box>

            <Box
                sx={{
                    color: "#405261",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "18px",
                    marginBottom: { xs: "20px", sm: "30px", md: "47px" },
                }}
            >
                Join the discussion on this article
            </Box>

            <Box
                sx={{
                    display: "flex",
                    gap: { xs: "16px", md: "30px" },
                    marginBottom: { xs: "16px", md: "30px" },
                    flexWrap: { xs: "wrap", md: "nowrap" },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minWidth: 0,
                    }}
                >
                    <Box
                        component="label"
                        sx={{
                            color: "#405261",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            marginBottom: "10px",
                        }}
                    >
                        Name
                    </Box>
                    <Box
                        component="input"
                        type="text"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                            if (errors.name) setErrors({ ...errors, name: null });
                        }}
                        placeholder=""
                        sx={{
                            width: "100%",
                            height: "40px",
                            borderRadius: "8px",
                            border: errors.name ? "1px solid #D32F2F" : "1px solid #D5DCE1",
                            background: "#FFF",
                            boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
                            padding: "0 12px",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                            "&:focus": {
                                borderColor: errors.name ? "#D32F2F" : "#148DFD",
                            },
                        }}
                    />
                    {errors.name && (
                        <Box sx={{ color: "#D32F2F", fontSize: "12px", mt: "4px", fontFamily: "Inter" }}>
                            {errors.name}
                        </Box>
                    )}
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minWidth: 0,
                    }}
                >
                    <Box
                        component="label"
                        sx={{
                            color: "#405261",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            marginBottom: "10px",
                        }}
                    >
                        Email
                    </Box>
                    <Box
                        component="input"
                        type="email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            if (errors.email) setErrors({ ...errors, email: null });
                        }}
                        placeholder=""
                        sx={{
                            width: "100%",
                            height: "40px",
                            borderRadius: "8px",
                            border: errors.email ? "1px solid #D32F2F" : "1px solid #D5DCE1",
                            background: "#FFF",
                            boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
                            padding: "0 12px",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                            "&:focus": {
                                borderColor: errors.name ? "#D32F2F" : "#148DFD",
                            },
                        }}
                    />
                    {errors.email && (
                        <Box sx={{ color: "#D32F2F", fontSize: "12px", mt: "4px", fontFamily: "Inter" }}>
                            {errors.email}
                        </Box>
                    )}
                </Box>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: "30px",
                }}
            >
                <Box
                    component="label"
                    sx={{
                        color: "#405261",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "normal",
                        marginBottom: "10px",
                    }}
                >
                    Comment
                </Box>
                <Box
                    component="textarea"
                    value={comment}
                    onChange={(e) => {
                        setComment(e.target.value);
                        if (errors.comment) setErrors({ ...errors, comment: null });
                    }}
                    placeholder=""
                    sx={{
                        width: "100%",
                        height: "128px",
                        borderRadius: "8px",
                        border: errors.comment ? "1px solid #D32F2F" : "1px solid #D5DCE1",
                        background: "#FFF",
                        boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
                        padding: "12px",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        outline: "none",
                        resize: "none",
                        boxSizing: "border-box",
                        "&:focus": {
                            borderColor: errors.comment ? "#D32F2F" : "#148DFD",
                        },
                    }}
                />
                {errors.comment && (
                    <Box sx={{ color: "#D32F2F", fontSize: "12px", mt: "4px", fontFamily: "Inter" }}>
                        {errors.comment}
                    </Box>
                )}
            </Box>

            <Box sx={{ display: "flex", justifyContent: { xs: "stretch", sm: "flex-end" } }}>
                <Box
                    component="button"
                    onClick={handlePostComment}
                    disabled={feedbackLoading}
                    sx={{
                        width: { xs: "100%", sm: "180px" },
                        height: "50px",
                        borderRadius: "8px",
                        background: feedbackLoading ? "#93A1B0" : "#148DFD",
                        boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
                        color: "#FFF",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "18px",
                        border: "none",
                        cursor: feedbackLoading ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "&:hover": {
                            background: feedbackLoading ? "#93A1B0" : "#1178D4",
                        },
                    }}
                >
                    {feedbackLoading ? (
                        <CircularProgress size={20} sx={{ color: "#fff" }} />
                    ) : (
                        "Post Comment"
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default LeaveCommentForm;
